import { createFileRoute, notFound } from '@tanstack/react-router';

import { ArticlePreviewPage } from '@/components/admin/article-preview-page';
import { adminHead } from '@/lib/seo';
import { adminPreviewArticleFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/articles_/$id_/preview')({
    component: ArticlePreviewRoute,
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') throw notFound();
        const data = await adminPreviewArticleFn({ data: { id: params.id } });
        if (!data) throw notFound();
        return data;
    },
    head: ({ loaderData, params }) => {
        const articleTitle = loaderData?.article?.title ?? 'תצוגה מקדימה';
        return adminHead(
            `${articleTitle} - תצוגה מקדימה`,
            `/admin/articles/${encodeURIComponent(params.id)}/preview`,
            'תצוגה מקדימה של כתבה בממשק הניהול.',
        );
    },
});

function ArticlePreviewRoute() {
    const data = Route.useLoaderData();
    return (
        <ArticlePreviewPage
            article={data.article}
            related={data.related}
            latest={data.latest}
        />
    );
}
